"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const native_base_1 = require("native-base");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const VStack_1 = __importDefault(require("../ui-components/VStack"));
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_1 = require("react");
const react_native_1 = require("react-native");
const FastImage_1 = __importDefault(require("../ui-components/FastImage"));
const ScrollCustomIndicator_1 = __importDefault(require("../ScrollCustomIndicator"));
const AppText_1 = require("../AppText");
const colors_1 = require("../../common/colors");
const constants_1 = require("../../common/constants");
const useDevice_1 = require("../../hooks/useDevice");
const character_1 = require("../../services/character");
const BigButton_1 = __importDefault(require("../GradientButton/BigButton"));
const GenericChip_1 = require("./GenericChip");
const CloseButton_1 = __importDefault(require("../AppButton/CloseButton"));
const modelArr = [
    { title: "Basic (Faster, Lower quality)", id: "black-forest-labs/flux-schnell" },
    { title: "Pro (Slower, Better Quality)", id: "black-forest-labs/flux-dev" },
];
const aspectRatioArr = [
    { title: "1:1", icon: pro_regular_svg_icons_1.faSquare },
    { title: "3:2", icon: pro_regular_svg_icons_1.faRectangle },
    { title: "4:3", icon: pro_regular_svg_icons_1.faRectangle },
    { title: "16:9", icon: pro_regular_svg_icons_1.faRectangleWide },
];
const ImageModels = ({ setValue, isOpen, onSelect, onClose, selectedStyle, selectedModel = "black-forest-labs/flux-schnell", selectedRatio = "16:9", showModelSelect = true, showAspectRatio = true, }) => {
    (0, react_1.useEffect)(() => {
        react_native_1.LogBox.ignoreLogs([constants_1.IGNORE_NESTED_SCROLL_LOG]);
    }, []);
    const { isWebDevice, isMobileScreen, isPortrait, isTabOrDesktopDevice, deviceWidth, deviceHeight, } = (0, useDevice_1.useDevice)();
    const [imageModels, setImageModels] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [currentModel, setCurrentModel] = (0, react_1.useState)(selectedModel);
    const [currentRatio, setCurrentRatio] = (0, react_1.useState)(selectedRatio);
    const [selectedImageModel, setSelectedImageModel] = (0, react_1.useState)();
    const loadImageModels = (0, react_1.useCallback)(async () => {
        setLoading(true);
        await (0, character_1.getCharacterImageModels)().then((imageApiModels) => {
            imageApiModels?.data && setImageModels(imageApiModels.data);
        });
        setLoading(false);
    }, [isOpen]);
    (0, react_1.useEffect)(() => {
        if (isOpen) {
            loadImageModels();
        }
    }, [isOpen]);
    (0, react_1.useEffect)(() => {
        setSelectedImageModel(imageModels?.find((imageModel) => (imageModel.styleString === selectedStyle)));
        console.log('imageModels:', selectedStyle);
        setCurrentModel(selectedModel);
        setCurrentRatio(selectedRatio);
    }, [imageModels, selectedStyle, selectedModel, selectedRatio]);
    const imageWidth = (0, react_1.useMemo)(() => deviceWidth / 2 - 16, [deviceWidth]);
    const Wrapper = (0, react_1.useCallback)(({ children }) => (isMobileScreen ? ((0, jsx_runtime_1.jsx)(native_base_1.Actionsheet, { isOpen: isOpen, onClose: onClose, useRNModal: true, width: isTabOrDesktopDevice ? (isPortrait ? "80%" : "60%") : "100%", bottom: isTabOrDesktopDevice ? "10%" : 0, left: isTabOrDesktopDevice ? (isPortrait ? "10%" : "20%") : 0, children: (0, jsx_runtime_1.jsx)(native_base_1.Actionsheet.Content, { style: {
                backgroundColor: colors_1.Colors.DARK_600,
                borderRadius: 16,
                minHeight: isTabOrDesktopDevice
                    ? isPortrait
                        ? (deviceHeight * 40) / 100
                        : (deviceHeight * 60) / 100
                    : deviceHeight - 120,
                padding: 8,
                maxWidth: 768,
            }, children: children }) }, "userStyleSelect")) : ((0, jsx_runtime_1.jsx)(react_native_1.Modal, { visible: isOpen, transparent: true, animationType: isOpen ? "slide" : "fade", children: (0, jsx_runtime_1.jsx)(native_base_1.View, { style: {
                backgroundColor: `${colors_1.Colors.DARK_700}CC`,
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
            }, children: (0, jsx_runtime_1.jsx)(VStack_1.default, { style: {
                    backgroundColor: colors_1.Colors.DARK_600,
                    maxHeight: deviceHeight - 150,
                    padding: 24,
                    borderRadius: 32,
                    maxWidth: 658,
                }, children: children }) }) }))), [isOpen, isMobileScreen, isTabOrDesktopDevice, isPortrait, deviceHeight, onClose]);
    return ((0, jsx_runtime_1.jsx)(Wrapper, { children: loading ? ((0, jsx_runtime_1.jsx)(VStack_1.default, { height: isWebDevice && !isMobileScreen ? 491 : deviceHeight / 1.75, width: isWebDevice && !isMobileScreen ? 572 : "100%", alignItems: "center", alignContent: "center", justifyContent: "center", children: (0, jsx_runtime_1.jsx)(native_base_1.Stack, { space: 8, alignItems: "center", width: "100%", children: (0, jsx_runtime_1.jsx)(native_base_1.Spinner, { style: { width: 100 }, size: "lg", color: colors_1.Colors.PRIMARY_BLUE }) }) })) : ((0, jsx_runtime_1.jsxs)(VStack_1.default, { style: styles.container, children: [(0, jsx_runtime_1.jsxs)(native_base_1.HStack, { justifyContent: "space-between", alignItems: "center", style: styles.header, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.white, fontWeight: isWebDevice && !isMobileScreen ? 600 : "auto", lineHeight: isWebDevice && !isMobileScreen ? 32 : "auto", style: { fontSize: isWebDevice && !isMobileScreen ? 24 : 20 }, children: "Select a style" }), (0, jsx_runtime_1.jsx)(CloseButton_1.default, { onClose: () => onClose?.(), verticalOffset: isMobileScreen ? 12 : 16, horizontalOffset: 16 })] }), (0, jsx_runtime_1.jsxs)(ScrollCustomIndicator_1.default, { style: styles.scrollView, contentContainerStyle: styles.scrollContent, showsVerticalScrollIndicator: false, children: [showModelSelect && ((0, jsx_runtime_1.jsxs)(native_base_1.View, { style: styles.section, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.DARK_100, style: { fontSize: isWebDevice && !isMobileScreen ? 14 : 16 }, lineHeight: isWebDevice && !isMobileScreen ? 17 : "auto", children: "Model" }), (0, jsx_runtime_1.jsx)(native_base_1.Select, { selectedValue: currentModel, minWidth: "200", minHeight: "44px", borderColor: colors_1.Colors.DARK_600, borderWidth: 1, backgroundColor: colors_1.Colors.DARK_700, color: colors_1.Colors.white, accessibilityLabel: "Select Model", placeholder: "Select Model", onValueChange: (itemValue) => {
                                        setCurrentModel(itemValue);
                                        console.log("Model selected:", itemValue);
                                    }, dropdownIcon: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faChevronDown, color: colors_1.Colors.white, style: { marginRight: 12 } }), _selectedItem: {
                                        bg: colors_1.Colors.DARK_700,
                                        color: colors_1.Colors.white,
                                    }, children: modelArr.map((model) => ((0, jsx_runtime_1.jsx)(native_base_1.Select.Item, { label: model.title, value: model.id }, model.id))) })] })), showAspectRatio && ((0, jsx_runtime_1.jsxs)(native_base_1.View, { style: styles.section, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.DARK_100, style: { fontSize: isWebDevice && !isMobileScreen ? 14 : 16 }, lineHeight: isWebDevice && !isMobileScreen ? 17 : "auto", children: "Aspect Ratio" }), (0, jsx_runtime_1.jsx)(native_base_1.View, { style: styles.aspectRatioContainer, children: aspectRatioArr.map((item) => ((0, jsx_runtime_1.jsx)(GenericChip_1.GenericChip, { leftContent: { type: 'text', value: item.title }, 
                                        // leftContent={{
                                        //   type: 'icon',
                                        //   value: item.icon
                                        // }}
                                        // rightContent={item.title}
                                        selected: currentRatio === item.title, onPress: () => {
                                            setCurrentRatio(item.title);
                                        } }, item.title))) })] })), (0, jsx_runtime_1.jsxs)(native_base_1.View, { style: styles.section, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.DARK_100, style: { fontSize: isWebDevice && !isMobileScreen ? 14 : 16 }, lineHeight: isWebDevice && !isMobileScreen ? 17 : "auto", children: "Style" }), (0, jsx_runtime_1.jsx)(native_base_1.View, { style: styles.imageGrid, children: imageModels?.map((imageModel) => {
                                        const isSelected = selectedImageModel?.id === imageModel.id;
                                        return ((0, jsx_runtime_1.jsx)(native_base_1.View, { style: [
                                                styles.imageCard,
                                                {
                                                    borderColor: isSelected ? colors_1.Colors.PRIMARY_BLUE : "transparent",
                                                    borderWidth: isSelected ? 2 : 0,
                                                },
                                            ], children: (0, jsx_runtime_1.jsx)(native_base_1.Pressable, { onPress: () => {
                                                    setSelectedImageModel(imageModel);
                                                }, children: (0, jsx_runtime_1.jsxs)(VStack_1.default, { children: [(0, jsx_runtime_1.jsx)(FastImage_1.default, { style: [
                                                                styles.image,
                                                                isWebDevice && !isMobileScreen && styles.desktopWebImage,
                                                            ], source: {
                                                                uri: imageModel.imageUrl,
                                                            }, resizeMode: "cover" }), (0, jsx_runtime_1.jsx)(react_native_linear_gradient_1.default, { colors: ["transparent", "black"], locations: [0.4375, 1], style: [
                                                                styles.imageGradient,
                                                                isWebDevice && !isMobileScreen && styles.desktopWebImage,
                                                            ] }), (0, jsx_runtime_1.jsxs)(native_base_1.HStack, { style: styles.imageLabel, children: [selectedStyle === imageModel.name &&
                                                                    !(isWebDevice && !isMobileScreen) && ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faCheck, size: 16, color: colors_1.Colors.SUCCESS })), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.white, fontSize: isWebDevice && !isMobileScreen ? 16 : "auto", fontWeight: isWebDevice && !isMobileScreen ? 500 : "auto", lineHeight: isWebDevice && !isMobileScreen ? 20 : "auto", children: imageModel.name })] })] }) }) }, `${imageModel.styleString}-model-image-view`));
                                    }) })] })] }), (0, jsx_runtime_1.jsx)(BigButton_1.default, { style: styles.setStyleButton, onPress: () => {
                        const finalSelection = {
                            modelId: currentModel,
                            aspectRatio: currentRatio,
                            imageModel: selectedImageModel,
                        };
                        setValue?.(finalSelection);
                        onSelect(finalSelection);
                        onClose?.();
                    }, children: "Set New Style" })] })) }));
};
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        width: '100%',
    },
    header: {
        padding: 16,
    },
    scrollView: {
        flex: 1,
    },
    scrollContent: {
        paddingHorizontal: 16,
    },
    section: {
        gap: 16,
        marginBottom: 24,
    },
    closeButton: {
        backgroundColor: colors_1.Colors.DARK_700,
        borderRadius: 20,
        padding: 8,
    },
    imageGrid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 16,
        justifyContent: "flex-start",
    },
    imageCard: {
        flex: 1,
        minWidth: 180,
        maxWidth: 300,
        borderRadius: 8,
    },
    image: {
        width: '100%',
        aspectRatio: 1.2,
        borderRadius: 10,
    },
    imageGradient: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 50,
    },
    imageLabel: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        padding: 8,
        alignItems: 'center',
        justifyContent: 'center',
    },
    setStyleButton: {
        marginHorizontal: 16,
        marginBottom: 24,
    },
    aspectRatioContainer: {
        flexDirection: "row",
        minHeight: 36,
        maxHeight: 44,
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 12,
    },
    desktopWebImage: {
        width: '100%',
        aspectRatio: 1.2,
        borderRadius: 12,
    },
});
exports.default = (0, react_1.memo)(ImageModels);
